import { DCEvent } from "@/events/eventsDomain";
import { DateInputProps, DateInputState } from "./DateInput";

const emptyDateInputState: DateInputState = { parsed: null, input: "", error: false };

export const prepDateInput = ({
  state,
  onInput,
  onChange,
}: {
  state: DateInputState | undefined;
  onInput: (updatedState: DateInputState) => DCEvent[];
  onChange: (updatedState: DateInputState) => DCEvent[];
}): DateInputProps => ({
  value: state?.input ?? "",
  onInput: (event) => onInput({ ...emptyDateInputState, ...state, input: event.target.value }),
  onChange: (updatedState, dispatch) => dispatch(onChange(updatedState)),
  error: state?.error,
});
